<script>
  import AyaLogo from '$components/aya-logo.svelte';
  import { erDataVersion } from '$lib/consts.generated';
</script>

<div class="container">
  <main>
    <slot />
  </main>
</div>
<footer>
  <section class="bottom">
    <AyaLogo type="full" />
    <span class="er-version">
      ER {erDataVersion}
    </span>
  </section>
  <span>
    © AYA.GG. Eternal Return and all related logos are trademarks of Nimble Neuron, inc. or its
    affiliates.
  </span>
  <a href="mailto:service+aya@metricsmith.gg">service+aya@metricsmith.gg</a>
</footer>

<style lang="postcss">
  @import '$lib/styles/breakpoints.css';

  .container {
    display: grid;
    grid-template-columns: 1fr;
    flex: 1 1 auto;
  }

  main {
    display: flex;
    flex-direction: column;

    @media (--sm) {
      margin: var(--space-6);
    }
    @media (--lg) {
      width: 70%;
      margin: var(--space-6) auto;
    }
  }

  footer {
    display: flex;
    gap: var(--space-3);
    flex-direction: column;
    margin: 0 var(--page-margin-x);
    margin-top: var(--space-4);
    padding-bottom: var(--page-margin-x);

    .bottom {
      display: flex;
      gap: var(--space-3);
      place-items: center;
    }

    & :global(.logo) {
      --logo-color: var(--mauve-6);
      width: 10rem;
    }
  }

  .er-version {
    padding: var(--space-2) var(--space-3);
    background-color: var(--mauve-3);
    border-radius: var(--radius-2);
  }
</style>
